import React, { useState, useRef, useEffect } from 'react';
import './styles.sass';

const FeedbackReasonModal = ({ onSubmit, onCancel }) => {
  const [feedbackReason, setFeedbackReason] = useState('');
  const [submitButtonEnabled, setSubmitButtonEnabled] = useState(false);
  const [visible, setVisible] = useState(true);

  const ref = useRef();
  const textareaRef = useRef();

  useEffect(() => {
    if (visible) {
      ref.current?.showModal();
      textareaRef.current?.focus();
    } else {
      ref.current?.close();
    }
  }, [visible]);

  const handleChange = (evt) => {
    const value = evt.target.value;
    setFeedbackReason(value);
    setSubmitButtonEnabled(value.trim() === '' ? false : true);
  };

  const closeAndExecute = (fn) => {
    return (evt) => {
      evt.preventDefault();
      fn(feedbackReason);
      setVisible(false);
    };
  };

  return (
    <dialog className="sentiment-feedback-modal" ref={ref} onCancel={closeAndExecute(onCancel)}>
      <div className="top-bar">
        <h1 className="title">Share your feedback</h1>
      </div>
      <div className="body">
        <div className="sentiment-banner">
          <div className="ai-sparkles" alt="AI generated content icon"></div>
          <p>
            This feature uses AI to assign sentiment scoring to posts that mention research. Although the quality of AI
            outputs is often high, they may contain incorrect information. The validity of the output should be verified
            by reviewing the referenced documents.
            <br />
            <a
              className="learn-more-link"
              href="https://help.altmetric.com/en/articles/10026177"
              target="_blank"
              rel="noreferrer"
            >
              Learn more about Sentiment Analysis
            </a>
          </p>
        </div>
        <form className="reason-form" id="reason-form" method="dialog" onSubmit={closeAndExecute(onSubmit)}>
          <label htmlFor="feedback-reason">Feedback Reason</label>
          <textarea
            ref={textareaRef}
            name="feedback-reason"
            type="text"
            value={feedbackReason}
            onChange={handleChange}
            placeholder="Tell us why you chose this rating (your feedback is anonymous)"
          ></textarea>
        </form>
      </div>

      <div className="bottom-bar">
        <a
          className="FeedbackReasonModal-terms"
          href="https://www.altmetric.com/terms-of-use/"
          target="_blank"
          rel="noreferrer"
        >
          Terms of use
        </a>
        <button className="cancel" onClick={closeAndExecute(onCancel)}>
          Cancel
        </button>
        <button form="reason-form" className="submit" type="submit" disabled={!submitButtonEnabled}>
          Send Feedback
        </button>
      </div>
    </dialog>
  );
};

export default FeedbackReasonModal;
